<script>

import { mapGetters, mapActions } from "vuex";
import axios from "axios";
var tokml = require("tokml")


export default {
  
  data() {
    return {
      showGrid: true,
      kmlfile: null,
      tempGrid: [],
      loading_image: false,
      image_conf: false
    };
  },
  watch: {
    "$root.displaybuttons": function (val) {
      this.showGrid = true;
    }
  },
  computed: {
    ...mapGetters(["currentLayer", "showButtons"])
  },
  methods: {
    ...mapActions(["private", "notPrivate", "getGrid", "setCurrentLayer"]),

    confirmPrivateSend() {
        this.$bvModal
        .msgBoxConfirm(
          "Пожалуйста, убедитесь что это точно секретные снимки, данное действие нельзя будет возвратить.",
          {
            title: "Вы уверены?",
            size: "md",
            buttonSize: "md",
            okVariant: "success",
            okTitle: "Да, уверен",
            cancelTitle: "Отмена",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(res => {
          if (res) this.private(this.currentLayer.id);
          this.eventBus.$emit("layerClicked", null);
        })
        .catch(err => {
          console.log(err);
        });
        
      
    },
    confirmNotPrivateSend() {
        this.$bvModal
          .msgBoxConfirm(
            "Пожалуйста, подтвердите завершение просмотра данного снимка, данное действие нельзя отменить",
            {
              title: "Вы уверены?",
              size: "md",
              buttonSize: "md",
              okVariant: "success",
              okTitle: "Да, уверен",
              cancelTitle: "Отмена",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true
            }
          )
          .then(async (res) => {
            this.image_conf = true
            if (res) await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v1/images/${this.currentLayer.id}/done`, {}, {
              headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.token)}`
              },
            }).then((e) => {
            this.image_conf = false
            this.eventBus.$emit("layerClicked", null);
            window.location.reload();
            window.location.href = '/'
            })
          })
          .catch(err => {
            console.log(err);
          });
          
    },
    handleGrid() {
      if (this.currentLayer) {
        this.$root.concealgrid = false
        this.getGrid(this.currentLayer.id)
      }
      this.showGrid= false
    },
    handleGridClose() {
      this.eventBus.$emit("layerClicked", this.currentLayer, true);
      this.showGrid = true
    },
    downloadKML() {
      var convertedArr = this.$root.globalpolygons.map((e) => (JSON.parse(e)))
      this.kmlfile = tokml({
        type: 'FeatureCollection',
        features: convertedArr
      })
      const url = window.URL.createObjectURL(new Blob([this.kmlfile], {type: 'application/xml'}));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'secret_zones.kml');
      document.body.appendChild(link);
      link.click();
      console.log()
    },
    async downloadImg() {
      // window.location.href = `${process.env.VUE_APP_BASE_URL}/api/v1/images/${this.currentLayer.id}/download`
      if (this.currentLayer) {
        this.$root.concealgrid = true
        await this.getGrid(this.currentLayer.id, true).then((e) => {
      setTimeout(() => {
      setTimeout(() => {
      this.showGrid = true
      this.kmlfile = tokml({
        type: 'FeatureCollection',
        features: this.$root.globalgrid
      })
      const url = window.URL.createObjectURL(new Blob([this.kmlfile], {type: 'application/xml'}));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${this.currentLayer.code}_grid.kml`);
      document.body.appendChild(link);
      link.click();
      console.log()
      }, this.$root.globalgrid)
      }, 1000)
      })
      }
    },
    async downloadLayer() {
      // window.location.href = `${process.env.VUE_APP_BASE_URL}/api/v1/images/${this.currentLayer.id}/download`
      if (this.currentLayer) {
        this.$root.concealgrid = true
        await this.getGrid(this.currentLayer.id, true)
      }
      this.showGrid = true
      this.kmlfile = tokml({
        type: 'FeatureCollection',
        features: this.$root.globalgrid
      })
      const url = window.URL.createObjectURL(new Blob([this.kmlfile], {type: 'application/xml'}));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'grid.kml');
      document.body.appendChild(link);
      link.click();
      console.log()
    },
    async downloadTile() {
      try{
      this.loading_image = true
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v1/images/${this.currentLayer.id}/download`, {
        headers: {
              'Authorization': `Bearer ${JSON.parse(sessionStorage.token)}`
        },
        responseType: 'blob',
      }).then((e) => {
      this.loading_image = false
      console.log(e)
      const url = window.URL.createObjectURL(e.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.currentLayer.code+'.TIF');
      document.body.appendChild(link);
      link.click();
      console.log(e.data)
      })
      } catch (e) {
        console.log(e)
        this.loading_image = false
        alert('Ошибка скачивания снимка!')
      }
    },
  },
  
  inject: ["eventBus"]
}

</script>

<style>
.actions-wrapper {
  position: absolute;
  display: flex;
  flex-direction: row;
  bottom: 5%;
  right: 5%;
  z-index: 2;
}
.actions-button {
  margin: 5px;
  color: #64b5f6;
}
</style>
<template>
  <div class="actions-wrapper">
    <b-button
      variant="success"
      class="actions-button"
      @click.prevent.stop="confirmNotPrivateSend()"
      v-if="this.$root.displaybuttons"
    >
      <b-icon icon="check2"  v-if="!this.image_conf" name="public">&nbsp;</b-icon>
      <b-icon icon="arrow-clockwise" animation="spin" v-if="this.image_conf" name="loading"></b-icon>
      <span  v-if="!this.image_conf">{{ "Завершить просмотр" }}</span>
    </b-button>
    <!--
    <b-button
      v-if="!this.showGrid"
      variant="danger"
      class="actions-button"
      @click.prevent.stop="confirmPrivateSend()"
    >
      <b-icon icon="x" name="private"></b-icon>&nbsp;
      <span class="btn-title">{{ "Не допущен" }}</span>
    </b-button> -->
    <b-button
      variant="info"
      class="actions-button"
      @click.prevent.stop="handleGrid()"
      v-if="this.showGrid"
    >
      <b-icon icon="map" name="check"></b-icon>&nbsp;
      <span>{{ "Сетка" }}</span>
    </b-button>
    <b-button
      variant="info"
      class="actions-button"
      outline
      @click.prevent.stop="handleGridClose()"
      v-if="!this.showGrid"
    >
      <span>{{ "Скрыть сетку" }}</span>
    </b-button>

    <b-button
      variant="info"
      class="actions-button"
      @click.prevent.stop="downloadImg()"
    >
      <b-icon icon="download" name="download"></b-icon
      ><span>{{ " Скачать сетку (KML)" }}</span>
    </b-button>
    <!-- <b-button
      variant="info"
      class="actions-button"
      @click.prevent.stop="downloadKML()"
      v-if="this.$root.globalpolygons.length > 0"
    >
      <b-icon icon="download" name="download"></b-icon
      ><span>{{ " Скачать обработанную сетку" }}</span>
    </b-button> -->
        <b-button
      variant="info"
      class="actions-button"
      @click.prevent.stop="downloadTile()"
    >
      <b-icon icon="download" v-if="!this.loading_image" name="download"></b-icon>
      <b-icon icon="arrow-clockwise" animation="spin" v-if="this.loading_image" name="loading"></b-icon>
    </b-button>
  </div>
</template>